import React from "react";
import {store} from "../Redux/store"
import { Provider } from "react-redux";
import { Initialize } from "./Initialize";
import PropTypes from 'prop-types';

export const  InitializeMirrorfly = (props)=>{
    return (
    <Provider store={store}>
        <Initialize initial={props}/>
    </Provider>
        );
}

InitializeMirrorfly.propTypes ={
    // apiUrl:PropTypes.string.isRequired,
    licenseKey:PropTypes.string.isRequired,
    userIdentifier:PropTypes.string.isRequired,
    profileName:PropTypes.string.isRequired
    // isSandBox:PropTypes.bool.isRequired,
    // isCallEnabled:PropTypes.bool.isRequired,
}

